import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  value?: Option | null;
  className?: string;
  styles?: any;
  onChange?: (option: Option | null) => void;
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  defaultValue,
  value,
  className,
  onChange,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(
    defaultValue,
  );

  // Met à jour selectedOption si value ou defaultValue change
  useEffect(() => {
    if (value !== undefined) {
      setSelectedOption(value || undefined);
    } else {
      setSelectedOption(undefined);
    }
  }, [value, defaultValue]);

  // Met à undefined si options est vide
  useEffect(() => {
    if (options.length === 0) {
      setSelectedOption(undefined);
      if (onChange) onChange(null);
    }
  }, [options, onChange]);

  const handleChange = (option: Option | null) => {
    // if (option === undefined) console.log("option est undefined");
    if (value === undefined) {
      setSelectedOption(option || undefined);
    }
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Selectionner"
      menuPortalTarget={document.body} // Affiche les options en dehors du flux DOM
      styles={{
        control: (base) => ({
          ...base,
          minWidth: 200,
          width: "100%",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // z-index élevé
      }}
    />
  );
};

export default CommonSelect;
